import { QRCodeCanvas } from 'qrcode.react';

export function GenerateQRIdTab({ viewedData }) {

  // Use the existing GeneralMessage hook
  const qrValue = JSON.stringify({
    id: viewedData?.id,
    employeeId: viewedData?.employeePersonalInformationEmployeeId,
  });

  const download = () => {
    // Find the canvas element generated by QRCodeCanvas
    const canvas = document.querySelector('canvas');
    if (!canvas) return;

    // Convert the canvas content to a downloadable PNG file
    const pngUrl = canvas
      .toDataURL('image/png') // create base64 image
      .replace('image/png', 'image/octet-stream'); // force download

    // Create a temporary link element
    const downloadLink = document.createElement('a');
    downloadLink.href = pngUrl;

    // Optional: include something in filename from qrValue (if possible)
    const fileName = `qr-code-${Date.now()}.png`;
    downloadLink.download = fileName;

    // Trigger the download
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  };

  return (
    <div className="generateId-tab">
      <div className="generateId-tab-body flex flex-col items-center justify-center">
        <QRCodeCanvas
          value={qrValue}
          size={300}
          bgColor="#ffffff"
          fgColor="#000000"
          level="H"
        />
        <button
          id="add-family"
          className="generate-submit save row mt-5"
          onClick={download}
        >
          DOWNLOAD
        </button>
      </div>
    </div>
  );
}